import React, { useState, useContext, useEffect } from 'react';
import { PersonContext } from '../../providers/Person';
import { s } from '../../Style.jsx';
import LabeledInput from '../../common/LabeledInput.jsx';
import FullDeliveryDetails from '../../common/FullDeliveryDetails.jsx';
import OrderItems from '../../common/OrderItems.jsx';
import requests from '../../utils/requests.js';

const Expanded = ({ order, setViewingOrder, setOrders }) => {
    const { auth } = useContext(PersonContext);

    const [loading, setLoading] = useState(false);
    const [loadingB, setLoadingB] = useState(false);

    const [editingItems, setEditingItems] = useState(false);
    const [editingInstructions, setEditingInstructions] = useState(false);

    const [items, setItems] = useState(order.items || []);
    useEffect(() => {
        setItems(order.items || []);
    }, [editingItems]);

    const [photos, setPhotos] = useState(order.photos || false);
    const [signature, setSignature] = useState(order.signature || false);
    const [notes, setNotes] = useState(order.notes || "");

    return <div style={s.mobileContainer}>

        <h2 style={{ marginBottom: 10 }}><s.BackArrow does={() => setViewingOrder(null)} />Order #{order.id}</h2>

        <FullDeliveryDetails setViewingOrder={setViewingOrder} setOrders={setOrders} order={order} />

        <div style={s.row}>
            <h3 style={{ marginBottom: 10 }}>Order Details</h3>
            <button style={s.button} onClick={() => setEditingItems(!editingItems)}>{editingItems ? "Cancel" : "Add Items"}</button>
        </div>

        {!loading && !editingItems && <OrderItems order={order} />}
        {loading && <div style={s.box}>
            <p style={{ ...s.rowCenter, justifyContent: "center" }}><i className="fas fa-spinner fa-spin"></i></p>
        </div>}

        {editingItems && <div style={s.box}>


            {!loading && <><div style={s.table}>
                {items.map((item, i) => <div style={s.cell(i)} key={i}>
                    <input style={{ flex: .5 }} value={item.notes} placeholder="Item" onChange={e => {
                        items[i].notes = e.target.value;
                        setItems([...items]);
                    }} />
                    <s.IconButton does={() => {
                        setItems(items.filter((_, j) => j !== i));
                    }} icon="fas fa-trash" />
                </div>)}
                <div style={s.cell(items.length || 0)}>
                    <s.IconButton does={() => {
                        setItems([...items, {}]);
                    }} icon="fas fa-plus" />
                </div>
            </div>
                <button onClick={() => {
                    setEditingItems(false);
                    requests.updateOrder({
                        auth,
                        setLoading,
                        id: order.id,
                        values: { items }
                    }).then(() => {
                        setViewingOrder({ ...order, items });
                        setOrders(orders => orders.map(o => o.id === order.id ? { ...o, items } : o));
                        setLoading(false);
                    });
                }}
                >Save</button>
            </>}
        </div>}

        {order.images && order.images.map((image, index) => <img key={index} src={image} style={{ width: "100%", maxWidth: 100, marginBottom: 10 }} />)}
        {order.signaturePhoto && <img src={order.signaturePhoto} style={{ width: "100%", maxWidth: 100, marginBottom: 10 }} />}

        <div style={s.row}>
            <h3 style={{ marginBottom: 10 }}>Driver Instructions</h3>
            <button style={s.button} onClick={() => setEditingInstructions(!editingInstructions)}>{editingInstructions ? "Cancel" : "Edit"}</button>
        </div>
        {loadingB && <div style={s.box}>
            <p style={{ ...s.rowCenter, justifyContent: "center" }}><i className="fas fa-spinner fa-spin"></i></p>
        </div>}

        {editingInstructions && <div style={s.box}>
            <div style={s.table}>
                <div style={s.cell(0)}>
                    <LabeledInput type="checkbox" label="Proof of Delivery Photos" value={photos} onChange={setPhotos} />
                </div>
                <div style={s.cell(1)}>
                    <LabeledInput type="checkbox" label="Customer Signature" value={signature} onChange={setSignature} />
                </div>
                <div style={s.cell(0)}>
                    <span>Instructions</span>
                    <textarea style={{ border: "1px solid #ccc", borderRadius: 4, padding: 10, width: 280, minHeight: 40 }} value={notes} onChange={e => setNotes(e.target.value)} />
                </div>
            </div>
            <button onClick={() => {
                setEditingInstructions(false);
                requests.updateOrder({
                    auth,
                    setLoading: setLoadingB,
                    id: order.id,
                    values: { photos, signature, notes }
                }).then(() => {
                    setViewingOrder({ ...order, photos, signature, notes });
                    setOrders(orders => orders.map(o => o.id === order.id ? { ...o, photos, signature, notes } : o));
                    setLoadingB(false);
                });
            }}
            >Save</button>
        </div>}

        {!loadingB && !editingInstructions && (order.photos || order.signature || order.notes) && <div style={s.box}>
            <div style={s.table}>
                {order.photos && <div style={s.cell(0)}>
                    <span style={{ fontSize: 14 }}>Proof of Delivery Photos</span>
                </div>}
                {order.signature && <div style={s.cell(1)}>
                    <span style={{ fontSize: 14 }}>Customer Signature</span>
                </div>}
                {order.notes && <div style={s.cell(0)}>
                    <span style={{ fontSize: 14, minWidth: 200 }}>Instructions</span>
                    <span style={{ fontSize: 12, padding: "10px 0" }}>{order.notes}</span>
                </div>}
            </div>
        </div>}


    </div>;

}

export default Expanded;